import PropTypes from "prop-types";
import React from "react";

const DoubleTick = props => {
  const { width, height, fill } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.88086 12.8852L10.1836 11.5771L10.6809 12.0765L16.4616 6.27172C16.8213 5.91049 17.4058 5.90927 17.767 6.26901C18.1282 6.62874 18.1294 7.2132 17.7697 7.57443L11.335 14.036C11.1618 14.2099 10.9264 14.3077 10.6809 14.3077C10.4354 14.3077 10.2001 14.2099 10.0268 14.036L8.88086 12.8852Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7669 6.26901C13.1281 6.62874 13.1293 7.2132 12.7696 7.57443L6.33489 14.036C6.16167 14.2099 5.9263 14.3077 5.68082 14.3077C5.43534 14.3077 5.19997 14.2099 5.02675 14.036L2.26901 11.2667C1.90927 10.9055 1.91049 10.321 2.27172 9.96132C2.63295 9.60158 3.21741 9.6028 3.57715 9.96403L5.68082 12.0765L11.4615 6.27172C11.8212 5.91049 12.4057 5.90927 12.7669 6.26901Z"
        fill={fill}
      />
    </svg>
  );
};

DoubleTick.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
};

DoubleTick.defaultProps = {
  fill: "#0ABDD4",
  height: 16,
  width: 16,
};

export default DoubleTick;
